// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BMalG06gmfA9vX8PNxeb {
    flex-basis: calc(33.333% - 10px);
    color: rgb(2, 99, 224);
    border: 1px solid rgba(2, 99, 224, 0.1);
    height: 6rem;
    font-size: 2rem;
    font-weight: 500;
    background: linear-gradient(
        135deg,
        rgba(255, 255, 255, 0.9) 0%,
        rgba(230, 240, 255, 0.6) 100%
    );
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    box-shadow:
        0 1px 3px rgba(2, 99, 224, 0.06),
        inset 0 1px 0 rgba(255, 255, 255, 0.8);
    cursor: pointer;
    transition: all 0.18s ease;
    border-radius: 16px;
    margin: 5px;
    position: relative;
    user-select: none;
    letter-spacing: 0.02em;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    line-height: 1;
}

.BMalG06gmfA9vX8PNxeb:hover {
    background: linear-gradient(
        135deg,
        rgba(235, 245, 255, 0.95) 0%,
        rgba(210, 230, 255, 0.7) 100%
    );
    border-color: rgba(2, 99, 224, 0.2);
    box-shadow:
        0 4px 12px rgba(2, 99, 224, 0.1),
        inset 0 1px 0 rgba(255, 255, 255, 0.9);
}

.BMalG06gmfA9vX8PNxeb:active {
    background: linear-gradient(
        135deg,
        rgba(215, 233, 255, 0.95) 0%,
        rgba(195, 220, 255, 0.8) 100%
    );
    transform: scale(0.95);
    box-shadow:
        0 1px 2px rgba(2, 99, 224, 0.1),
        inset 0 2px 4px rgba(2, 99, 224, 0.08);
}

.BMalG06gmfA9vX8PNxeb:focus-visible {
    outline: 2px solid rgba(2, 99, 224, 0.4);
    outline-offset: 2px;
}

.BMalG06gmfA9vX8PNxeb:disabled,
.BMalG06gmfA9vX8PNxeb[disabled] {
    color: rgb(174, 178, 193);
    cursor: not-allowed;
    background: rgba(245, 245, 250, 0.6);
    border-color: rgba(174, 178, 193, 0.15);
    box-shadow: none;
}

.BMalG06gmfA9vX8PNxeb:disabled:hover,
.BMalG06gmfA9vX8PNxeb[disabled]:hover {
    background: rgba(245, 245, 250, 0.6);
    transform: none;
    box-shadow: none;
}

.m0KfklIAVY0VlAznR5m7 {
    display: block;
    font-size: 0.55rem;
    font-weight: 500;
    color: rgba(2, 99, 224, 0.4);
    letter-spacing: 0.2em;
    margin-top: 3px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Dialer/DtmfButton.module.css"],"names":[],"mappings":"AAAA;IACI,gCAAgC;IAChC,sBAAsB;IACtB,uCAAuC;IACvC,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB;;;;KAIC;IACD,0BAA0B;IAC1B,kCAAkC;IAClC;;8CAE0C;IAC1C,eAAe;IACf,0BAA0B;IAC1B,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI;;;;KAIC;IACD,mCAAmC;IACnC;;8CAE0C;AAC9C;;AAEA;IACI;;;;KAIC;IACD,sBAAsB;IACtB;;8CAE0C;AAC9C;;AAEA;IACI,wCAAwC;IACxC,mBAAmB;AACvB;;AAEA;;IAEI,yBAAyB;IACzB,mBAAmB;IACnB,oCAAoC;IACpC,uCAAuC;IACvC,gBAAgB;AACpB;;AAEA;;IAEI,oCAAoC;IACpC,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,4BAA4B;IAC5B,qBAAqB;IACrB,eAAe;AACnB","sourcesContent":[".button {\n    flex-basis: calc(33.333% - 10px);\n    color: rgb(2, 99, 224);\n    border: 1px solid rgba(2, 99, 224, 0.1);\n    height: 6rem;\n    font-size: 2rem;\n    font-weight: 500;\n    background: linear-gradient(\n        135deg,\n        rgba(255, 255, 255, 0.9) 0%,\n        rgba(230, 240, 255, 0.6) 100%\n    );\n    backdrop-filter: blur(8px);\n    -webkit-backdrop-filter: blur(8px);\n    box-shadow:\n        0 1px 3px rgba(2, 99, 224, 0.06),\n        inset 0 1px 0 rgba(255, 255, 255, 0.8);\n    cursor: pointer;\n    transition: all 0.18s ease;\n    border-radius: 16px;\n    margin: 5px;\n    position: relative;\n    user-select: none;\n    letter-spacing: 0.02em;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    line-height: 1;\n}\n\n.button:hover {\n    background: linear-gradient(\n        135deg,\n        rgba(235, 245, 255, 0.95) 0%,\n        rgba(210, 230, 255, 0.7) 100%\n    );\n    border-color: rgba(2, 99, 224, 0.2);\n    box-shadow:\n        0 4px 12px rgba(2, 99, 224, 0.1),\n        inset 0 1px 0 rgba(255, 255, 255, 0.9);\n}\n\n.button:active {\n    background: linear-gradient(\n        135deg,\n        rgba(215, 233, 255, 0.95) 0%,\n        rgba(195, 220, 255, 0.8) 100%\n    );\n    transform: scale(0.95);\n    box-shadow:\n        0 1px 2px rgba(2, 99, 224, 0.1),\n        inset 0 2px 4px rgba(2, 99, 224, 0.08);\n}\n\n.button:focus-visible {\n    outline: 2px solid rgba(2, 99, 224, 0.4);\n    outline-offset: 2px;\n}\n\n.button:disabled,\n.button[disabled] {\n    color: rgb(174, 178, 193);\n    cursor: not-allowed;\n    background: rgba(245, 245, 250, 0.6);\n    border-color: rgba(174, 178, 193, 0.15);\n    box-shadow: none;\n}\n\n.button:disabled:hover,\n.button[disabled]:hover {\n    background: rgba(245, 245, 250, 0.6);\n    transform: none;\n    box-shadow: none;\n}\n\n.sub {\n    display: block;\n    font-size: 0.55rem;\n    font-weight: 500;\n    color: rgba(2, 99, 224, 0.4);\n    letter-spacing: 0.2em;\n    margin-top: 3px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `BMalG06gmfA9vX8PNxeb`,
	"sub": `m0KfklIAVY0VlAznR5m7`
};
export default ___CSS_LOADER_EXPORT___;
